import { render, staticRenderFns } from "./detailImportAverageWageDetil.vue?vue&type=template&id=7c4de1e0&"
import script from "./detailImportAverageWageDetil.vue?vue&type=script&lang=js&"
export * from "./detailImportAverageWageDetil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports